import { render, staticRenderFns } from "./KonsensusKaedah.vue?vue&type=template&id=a6d9e750&scoped=true"
import script from "./KonsensusKaedah.vue?vue&type=script&lang=js"
export * from "./KonsensusKaedah.vue?vue&type=script&lang=js"
import style0 from "./KonsensusKaedah.vue?vue&type=style&index=0&id=a6d9e750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d9e750",
  null
  
)

export default component.exports